<template>
  <div>
    <div class="row" id="select-user" v-if="users.length > 0">
      <div class="col-4">
        <label class="center-label-select">
          {{ usersLabel }}
        </label>
      </div>
      <div class="col-8">
        <div class="key-account-box">
          <key-account-picker :multiple="usersMultiple" :users="users" :currentUser="currentUser" @changeUser="changeUsers"></key-account-picker>
        </div>
      </div>
    </div>
    <div class="row" id="select-shop">
      <div class="col-4">
          <label class="center-label-select">
            {{ shopsLabel }}
          </label>
      </div>
      <div class="col-8">
        <div class="key-account-box">
          <shop-picker :multiple="shopsMultiple" :shop="currentShop" :shops="shops" @update:shop="changeShops"></shop-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import KeyAccountPicker from './KeyAccountPicker/KeyAccountPicker';
import ShopPicker from '../Panel/Account/ShopPicker';

export default {
    name: 'KeyAccountShops',
    props: {
      currentUser: undefined,
      currentShop: undefined,
      users: {
        type: Array,
        default: function(){
          return [];
        }
      },
      shops:{
        type: Array,
        default: function(){
          return [];
        }
      },
      usersLabel: {
        type: String,
        default: 'Select User'
      },
      shopsLabel: {
        type: String,
        default: 'Select Shop'
      },
      usersMultiple: {
        type: Boolean,
        default: false
      },
      shopsMultiple: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      changeUsers(data){
        this.$emit('change:users', data);
        this.$emit('change:shops', undefined);
      },
      changeShops(data){
        this.$emit('change:shops', data);
      }
    },
    components: {
      'key-account-picker': KeyAccountPicker,
      'shop-picker': ShopPicker
    }
};
</script>

<style lang="scss" scoped>
  #select-shop, #select-user{
    padding: 5px;
    label{
      line-height: 31px;
    }
  }
</style>
